<template>
    <span class="upload-box">
        <span v-show="enabled" class="upload-btn">
            <slot :scope="scope"></slot>
        </span>
        <div class="upload-files">
          <span class="uplaod-file" v-for="doc in docs" v-bind:key="doc.DOCUMENT_ID">
              <a v-if="isImg(doc)" class="fileinput-filename thumbImg" :data-id="doc.DOCUMENT_ID"
                :data-caption="doc.S_ORIGINAL_NAME" :data-group="id" data-magnify="gallery"  :data-src="doc.src">{{doc.S_ORIGINAL_NAME}}</a>
              <a v-else target="blank" class="fileinput-filename" :title="doc.S_ORIGINAL_NAME"
                  v-text="doc.S_ORIGINAL_NAME"></a>
              <a class="fileclose" title="文件下载" @click="getFile(doc.src)"><i class="el-icon-bottom"></i></a>
              <a class="fileclose" title="文件预览" @click="proviewFile(doc)"><i class="el-icon-view"></i></a>
              <a class="fileclose" v-show="enabled" title="删除文件" @click="deleteFile(doc.DOCUMENT_ID)"><i class="el-icon-close"></i></a>
          </span>
        </div>

        <layui-listfileupload ref="listFile" v-show="0" :targetEl="targetEl" />
    </span>
</template>
<script>
import "../../../static/plugin/plupload/queue/css/jquery.plupload.queue.css";
import "../../../static/plugin/plupload/plupload.js"
import "../../../static/plugin/plupload/queue/jquery.plupload.queue.js"
import "../../../static/plugin/plupload/plupload.html4.js"
import "../../../static/plugin/plupload/plupload.html5.js"
import "../../../static/plugin/plupload/plupload.flash.js"
import "../../../static/plugin/plupload/zh_CN.js"
export default {
    name: 'LayuiFileUpload',
    props: {
        requestUniqueId: {
            type: String, // // 请求唯一标识，必须有
            default: () => {
                return 'LayuiFileUpload-' + window.uuid();
            },
        },
        _model: {
            default: '',
            required: false
        },
        enabled: {
            type: Boolean,
            default: ()=>{
                return true;
            }
        },
        targetEl: {
            type: String,
            default: '.layui-body'
        },
        uploadTitle: {
            type: String,
        },
        filters: {
            type: Array,
            default: ()=> {
                return []
            }
        },
        max : {
            type: Number,
            default : -1
        },
    },
    model: {
        prop: '_model',
        event: '_modelEvent'
    },
    data() {
        return {
            id: null,
            scope: this,
            fileNum: 0,
            docs : []
        }
    },
    mounted() {
        var element = this.el = $(this.$el);
        var id = this.id = this.uuid();
        this.tid = this.security.getUser().getToken();
        this.url = process.env.REPOSITORY_HOST + '/file/preViewUpload?token=' + this.tid ;
    },
    methods: {
        upload() {
            if(this.fileNum == this.max) {
                this.layer.openAlert("只允许上传" + this.max + "个文件!", undefined, undefined, { targetEl: this.targetEl });
                return;
            }
            var that = this;
            $("#" + this.id).remove();
            this.el.find('.layuiupload').attr("id", this.id);
            var uploadEl = this.getUploadTemplate();
            uploadEl = $(uploadEl);
            uploadEl.attr('id', this.id);
            $("body").append(uploadEl);
            this.layer.openPop(this.id, this.uploadTitle ? this.uploadTitle : '上传', null, 380, true, undefined, this.targetEl);
            uploadEl.find(".filePlace").pluploadQueue({
                runtimes : 'html5,flash',
                url : that.url,
                unique_names : true,
                filters : this.filters.length > 0 ? [{title : "", extensions : this.filters.join(",")}] : "",
                init:{
                    FileUploaded: function(uploader,file,response){
                        if(response.response){
                            var result = JSON.parse(response.response);
                            if(result.error) {
                                console.error(result.error);
                            } else {
                                var addDoc = result.doc;
                                var obj = {};
                                for(var p in addDoc) {
                                    obj[p.toUpperCase()] = addDoc[p];
                                }
                                that.fileNum ++;
                                that.docs.push(that.wrapDoc(obj));
                                that.ui_update = true;
                                that.$emit('_modelEvent', that.buildValue());

                                that.$nextTick(()=>{
                                    that.renderPictureView();
                                })
                            }
                            that.layer.closePop(that.id)
                        }
                    },
                    UploadComplete: function(uploader,fs){
                        uploader.refresh();
                        uploader.destroy();//ie9以下若不销毁此对象第二次上传会十分缓慢
                    },
                    FilesAdded: function(uploader, files){
                        if(that.max > 0 && that.fileNum + uploader.files.length > that.max) {
                            while(uploader.files.length > 0){
                                uploader.removeFile(uploader.files[0]);
                            }
                            that.layer.openAlert("只允许上传" + that.max + "个文件!", undefined, undefined, { targetEl: this.targetEl });
                            return;
                        }
                    },
                }
            });
        },
        getUploadTemplate() {
            return `<div class="layuiupload"style="display: none;">
                        <div class="filePlace"></div>
                        </div>
                    </div>`
        },
        proviewFile(file) {
          this.$refs['listFile'].preView(file)
        },
        deleteFile(docId){
             this.layer.openConfirm('确定要删除这个文件吗?', ()=> {
                for(var i = 0 ; i < this.docs.length; i ++) {
                    var doc = this.docs[i];
                    if(doc.DOCUMENT_ID == docId){
                        this.docs.remove(doc);
                        this.ui_update = true;
                        this.$emit('_modelEvent', this.buildValue());
                        return;
                    }
                }
            }, undefined, { targetEl: this.targetEl });
        },
        buildValue(){
            var value = [];
            for(var i = 0 ; i < this.docs.length; i ++) {
                var doc = this.docs[i];
                value.push(doc.DOCUMENT_ID);
            }
            return value.join(",");
        },
        setValue(value) {
            if(!this.ui_update) {
                if(!value) {
                    this.docs = [];
                } else {
                    this.api.queryList(
                            'DB_DOCUMENT',
                            {p2: {'DOCUMENT_ID:1': value}},
                            this.requestUniqueId
                    ).then(response => {
                        var results = response.result;
                        for(var i = 0; i < results.length; i++) {
                            var result = results[i];
                            if(!this.containsDoc(result.DOCUMENT_ID)) {
                                this.docs.push(this.wrapDoc(result));
                            }
                        }
                        this.fileNum = results.length;
                        this.$nextTick(()=> {
                            this.renderPictureView();
                        });
                    });
                }
            }
            this.ui_update = false;
            this.fileNum = this.docs.length;
        },
        containsDoc(docId) {
            for(var i = 0 ; i < this.docs.length; i ++) {
                var doc = this.docs[i];
                if(doc.DOCUMENT_ID == docId) {
                    return true;
                }
            }
        },
        wrapDoc(doc) {
            return this.$refs['listFile'].wrapFile(doc)
            doc.src = process.env.REPOSITORY_HOST + '/file/get/' + doc.DOCUMENT_ID + '?token=' + this.tid;
            return doc;
        },
        getFile(docId) {
            window.open(docId);
        },

        renderPictureView() {
          this.el.find(".thumbImg").Magnify({
              Toolbar: [
                  'prev',
                  'next',
                  'rotateLeft',
                  'rotateRight',
                  'zoomIn',
                  'actualSize',
                  'zoomOut'
              ],
              keyboard: true,
              draggable: true,
              movable: true,
              modalSize: [800, 600],
              targetEl: this.targetEl
          });
        },

        isImg (file) {
          return this.$refs['listFile'].isImg(file)
        }
    },
    watch:{
        _model: {
          handler: function (value){
            // value && this.setValue(value);
            this.setValue(value || '');
          },
          immediate: true
        },
    }
}
</script>

<style lang="postcss">
.upload-box {
  & .upload-files {
    white-space: pre-wrap;
  }
  & .uplaod-file {
    margin-top: 4px;
    margin-right: 4px;
    margin-bottom: 4px;

    padding: 0 4px;

    display: inline-flex;
    align-items: center;
    border: 1px solid #CCCCCC;
    border-radius: 16px;
    background-color: #F1F6FF;
    &:last-child {
      /* margin-right: 0; */
    }
  }
    & .uplaod-file:hover {

    border: 1px solid#3566EE;
    border-radius: 16px;
    background-color: #F1F6FF;
    }
  & .uplaod-file:hover {
    background: #f5f7fa;
  }
  & .fileinput-filename {
    margin-left: 8px;
    color:blue;
    /* color: #606266; */
    /* cursor:pointer; */
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width:120px
  }
  & .fileclose {
    padding: 0 5px;
    font-size: 14px;
    /* color: red; */
    cursor:pointer
  }
    & .fileclose:hover {
    padding: 0 5px;
    font-size: 14px;
    color: #002BA2;
    cursor:pointer；
  }

}
</style>



// WEBPACK FOOTER //
// src/components/common/LayuiFileUpload.vue